import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { TaskResponseDto } from '@nx-frontend/shared/types';
import { ExportNotePayload } from '@nx-frontend/shared/types';

export async function exportNote({
  userId,
  workspaceId,
  noteId,
  options,
}: ExportNotePayload): Promise<TaskResponseDto> {
  const { data } = await axiosClient.post<TaskResponseDto>(
    `${generalEnv.noteServiceUrl}/v1/workspaces/${workspaceId}/notes/${noteId}/export`,
    options,
    {
      headers: {
        Authorization: `internal ${userId}:auto`,
      },
    }
  );
  return data;
}
